
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dzfbcqazhcoggosesssc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6ZmJjcWF6aGNvZ2dvc2Vzc3NjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMxMzc0NjUsImV4cCI6MjA1ODcxMzQ2NX0.PiHiTN5QufslNqvvmfKBhZtG-vER16nmgpLlsT5ktZo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create a single instance of the Supabase client to be used throughout the app
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY
);

// Test that the supabase client is exported correctly
console.log("⭐ Supabase Client: URL is set:", !!SUPABASE_URL);
console.log("⭐ Supabase Client: Key is set:", !!SUPABASE_PUBLISHABLE_KEY);
